




























import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import WidgetCard from '@/modules/common/widgets/components/WidgetCard.vue'
import WidgetPhone from '@/modules/common/widgets/components/tools/WidgetPhone.vue'
import WidgetQuote from '@/modules/common/widgets/components/tools/WidgetQuote.vue'
import WidgetClock from '@/modules/common/widgets/components/tools/WidgetClock.vue'
import { Prop } from 'vue-property-decorator'
import { WidgetResourceType, WidgetSize } from '@/modules/common/widgets/models/widget-resource.model'
import WidgetTomanConverter from '@/modules/common/widgets/components/tools/WidgetTomanConverter.vue'
import WidgetNews from '@/modules/common/widgets/components/tools/WidgetNews.vue'


@Component({
  components: { WidgetClock, WidgetQuote, WidgetPhone, WidgetCard }
})
export default class WidgetContainer extends Vue {
  @Prop({ default: false }) dark !: boolean
  widgetResource: WidgetResourceType = widgetResource(this.dark, this.$q.screen)

  widgetContainer = {
    width: '100%',
    display: 'grid',
    gridAutoFlow: 'column',
    gridTemplateColumns: (this.$q.screen.gt.lg) ? 'repeat(3, 1fr)' : 'repeat(2, 1fr)',
    gridTemplateRows: 'repeat(3, 27vh)',
    gridColumnGap: '2rem',
    gridRowGap: '2rem',
    padding: '2rem'
  }
}

function widgetResource(dark, size): WidgetResourceType {
  let widgets: WidgetResourceType = [
    {
      component: WidgetPhone,
      label: 'دفترچه تلفن 📠',
      center: false,
      dark: dark,
      id: 1,
      glossiness: false,
      size: WidgetSize.MID
    },
    {
      component: WidgetQuote,
      label: 'سخن بزرگان 🗒',
      center: true,
      dark: dark,
      id: 2,
      glossiness: true,
      size: WidgetSize.SMALL
    },
    {
      component: WidgetClock,
      label: 'ساعت 🕰',
      center: true,
      dark: dark,
      id: 3,
      glossiness: true,
      size: WidgetSize.BIG
    },
    {
      component: WidgetTomanConverter,
      label: 'تبدیل تومان به ریال 💱️',
      center: false,
      dark: dark,
      id: 4,
      glossiness: false,
      size: WidgetSize.SMALL
    },
    {
      component: WidgetNews,
      label: 'اخبار 🗞️',
      center: true,
      dark: dark,
      id: 5,
      glossiness: true,
      size: WidgetSize.MID
    }
  ]

  // if (!size.gt.lg) {
  //   return widgets.filter(widget => {
  //     return (widget.id !== 4 && widget.id !== 5)
  //   })
  // } else
  return widgets
}

